
export const calendarHeaders = {
  'x-version': '1.0.0',
  'x-app-id': 'BNsiR9uq7yfW0LVz'
}



// WEBPACK FOOTER //
// ./src/commons/headers.js